document.addEventListener("DOMContentLoaded", function() {

    try {

        document.querySelectorAll('.fancy-drop-down-value').forEach(function(element) {
            element.parentElement.querySelectorAll('.fancy-drop-down li').forEach( function(childElement) {
                childElement.addEventListener('click', function() {
                    debugger
                    element.parentElement.querySelector('.fancy-drop-down').classList.add('hidden')
                    var value = childElement.getAttribute('value')
                    let option = childElement?.getAttribute('id-option')?.split('-')
                    var event = new Event('change', {
                        bubbles: true,
                        cancelable: true,
                    });
                    element.parentElement.querySelector('.fancy-drop-down-value span').innerText = value
                    element.parentElement.querySelector('select').value = value
                    element.parentElement.querySelector('select').dispatchEvent(event);
                    if(option[0] === 'color') {
                        window.media = parseInt(option[1]) * 2 - 1;
                        let count = window.media
                        if ( document.querySelector('input[name="front_engraving"]:checked').value == 'yes' && document.querySelector('input[name="back_engraving"]:checked')?.value == 'yes') count++;
                        if ( document.querySelector('input[name="front_engraving"]:checked').value == 'yes' && document.querySelector('input[name="back_engraving"]:checked')?.value == 'no') count++;
                        if ( document.querySelector('input[name="front_engraving"]:checked').value == 'yes' && document.querySelector('input[name="back_engraving"]:checked') === null) count++;
                        window.updateCanvas(count)
                    }
                })
            
            })
            element.addEventListener('click', function(event) {
                document.querySelectorAll('.fancy-drop-down-value').forEach(item => {
                    if(item === this) {
                        console.log("item", item);
                        item.nextElementSibling.classList.toggle('hidden')
                    } else if(!item.nextElementSibling.classList.contains('hidden')) {
                        item.nextElementSibling.classList.add('hidden')
                    }
                })
            });
        })

        window.addEventListener("click", (event) => {
            if(!(event.target.classList.contains('fancy-drop-down-value') || event.target.classList.contains('fancy-drop-down-value-item'))) {
                
                document.querySelectorAll('.fancy-drop-down-value').forEach(function(element) {
                    element.parentElement.querySelector('.fancy-drop-down').classList.add('hidden')
                    
                })
            }
        })
    } catch (error) {
        console.log(error)
    }
}, false);


$('.custom-slider').slick({
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrow: true,
    dots: false,
    lazyLoad:"progressive",
    swipe:true,
    swipeToSlide:true,
    responsive: [
        {
            breakpoint: 1442,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 600,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: true,
                dots: false,
                slidesToShow:2,
                swipe:true,
                swipeToSlide:true
            }
        },
        
    ]
});


$('.custom-slider-collapsible').slick({
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrow: true,
    dots: false,
    lazyLoad:"progressive",
    swipe:true,
    swipeToSlide:true,
    responsive: [
        {
            breakpoint: 1442,
            settings: {
                slidesToShow: 4,
                swipe:true,
                swipeToSlide:true
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2,
                swipe:true,
                swipeToSlide:true
            }
        },
        {
            breakpoint: 600,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                swipe:true,
                swipeToSlide:true
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: true,
                dots: false,
                slidesToShow:2,
                swipe:true,
                swipeToSlide:true
            }
        },
        
    ]
});
// custom variant swatch images
jQuery(document).ready(function () {
    var currentVal = $('.cust-radio-pills  input:radio:checked').val();
    jQuery('.cust-option-value-swatch').html(currentVal);
    var currentVal2 = $('.cust-radio-pills .custom-swatch input:radio:checked').val();
    jQuery('.cust-option-value').html(currentVal2);

    $('.cust-radio-pills .custom-swatch-color  input:radio').change(function () {
        var radioVar = jQuery(this).val();
        jQuery('.cust-option-value-swatch').html(radioVar);
    });
    $('.cust-radio-pills .custom-swatch input:radio').change(function () {
        var radioVar2 = jQuery(this).val();
        jQuery('.cust-option-value').html(radioVar2);
    });
});

// announcemnt bar
jQuery(document).ready(function () {
    var wWidth = jQuery(window).width();
    if (wWidth <= 600) {
        console.log('check if');
        jQuery('#shopify-section-announcement-bar').addClass('custom-slider');
        $('#shopify-section-announcement-bar').slick({
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrow: false,
            dots: false,
            fade: true,
            cssEase: 'linear',
            swipe:true,
            swipeToSlide:true

        });
    };
});

// Press page slider
$('.press-slider-area').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: true,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: true,
                dots: false,
                slidesToShow: 2,
                swipe:true,
                swipeToSlide:true
            }
        }
    ]
});



